import confetti from 'canvas-confetti';

export function burstConfettiFromElement(el: HTMLElement) {
	const rect = el.getBoundingClientRect();
	const x = (rect.left + rect.width / 2) / window.innerWidth;
	const y = (rect.top + rect.height / 2) / window.innerHeight;

	const base = {
		origin: { x, y },
		startVelocity: 35,
		spread: 70,
		ticks: 220,
		zIndex: 9999,
	};

	confetti({ ...base, particleCount: 90, scalar: 1.0 });
	confetti({ ...base, particleCount: 45, scalar: 0.85, startVelocity: 28, spread: 90 });
}
